import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { chartColorPallet as DEFAULT_COLORS } from '@/config/colorPallets/universalDesignSystem';
import useSelections from '@/components/widget/misc/useSelections';
import Loading from './Loading';
import useData from '../internal/PointChart/useData';
import PointChart from '../internal/PointChart';
import { isCategorical } from '../internal/PointChart/utils';
import settings, { selectionConfig, labelsSelectionConfig, legendsSelectionConfig } from './settings';
import { jsx as _jsx } from "react/jsx-runtime";

const BubbleChart = _ref => {
  let props = Object.assign({}, _ref);
  const {
    0: isLoadingDeps,
    1: setIsLoadingDeps
  } = useState(false);
  const {
    0: hasLoadedDeps,
    1: setHasLoadedDeps
  } = useState(false); // Load Chart Deps

  useEffect(() => {
    if (isLoadingDeps || hasLoadedDeps) {
      return;
    }

    setIsLoadingDeps(true);

    (async () => {
      const {
        default: Chart,
        ArcElement,
        Tooltip,
        Legend
      } = await import('chart.js/auto');
      const {
        default: ChartDataLabels
      } = await import('chartjs-plugin-datalabels');
      const {
        default: CustomBackground
      } = await import('../plugins/customBackground');
      const {
        default: ActiveDatasetHighlight
      } = await import('../plugins/activeDatasetHighlightPlugin');
      const {
        default: ResponsiveResizePlugin
      } = await import('../plugins/responsiveResizePlugin');
      const {
        default: LegendPaddingPlugin
      } = await import('../plugins/legendPadding');
      const {
        default: AxisLabelClickPlugin
      } = await import('../plugins/axisLabelClickPlugin');
      Chart.register(ArcElement, Tooltip, Legend, ChartDataLabels, ActiveDatasetHighlight, CustomBackground, ResponsiveResizePlugin, LegendPaddingPlugin, AxisLabelClickPlugin);
      setHasLoadedDeps(true);
      setIsLoadingDeps(false);
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/_jsx(PointChart, _objectSpread(_objectSpread({}, props), {}, {
    chartType: "bubble",
    settings: settings,
    Loading: Loading,
    selectionConfig: selectionConfig,
    labelsSelectionConfig: labelsSelectionConfig,
    legendsSelectionConfig: legendsSelectionConfig,
    legendsSelectionSkipCount: 2,
    hasLoadedDeps: hasLoadedDeps
  }));
};

export default BubbleChart;
export { selectionConfig, labelsSelectionConfig, useData, useSelections, isCategorical, DEFAULT_COLORS };